<template>
  <div class="article-detail-page">
    <div v-if="loading" class="loading-state">
      Loading article content...
    </div>
    
    <div v-else-if="article">
      <section class="hero">
        <div class="container">
          <div class="hero-content">
            <h1>{{ article.title }}</h1>
            <hr class="hero-divider" />
            <p class="hero-date">{{ article.date }}</p>
          </div>
        </div>
      </section>

      <section class="article-content">
        <div class="boundary-image-container" v-if="article.imageSrc">
          <img :src="getImage(article.imageSrc)" :alt="article.title" />
        </div>
        <div class="container">

          <div class="article-body">
            <div class="article-text" v-html="article.content"></div>
            <div class="back-to-articles">
              <button class="back-button" @click="goBack">← Back to Articles</button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div v-else class="error-state">
      <p>Article not found.</p>
      <div class="back-to-articles">
        <button class="back-button" @click="goBack">← Back to Articles</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ArticleDetailPage',
  data() {
    return {
      article: null,
      loading: true
    };
  },
  mounted() {
    this.fetchArticle();
  },
  methods: {
    async fetchArticle() {
      const articleId = this.$route.params.id;
      try {
        const response = await axios.get(`/api/article/${articleId}`);
        this.article = response.data;
        // 清除 Word 导出 HTML 中每段之间的空占位段落
        if (this.article && this.article.content) {
          this.article.content = this.cleanContent(this.article.content);
        }
      } catch (error) {
        console.error('Failed to fetch article details:', error);
      } finally {
        this.loading = false;
      }
    },
    // 移除 Word 导出 HTML 中只含 &nbsp; 或空白的段落
    cleanContent(html) {
      return html
        // 移除只含 &nbsp; 的 span 包裹的段落
        .replace(/<p[^>]*>\s*<span[^>]*>\s*(&nbsp;|\u00a0)\s*(<o:p><\/o:p>)?\s*<\/span>\s*<\/p>/gi, '')
        // 移除只含 &nbsp; 的段落
        .replace(/<p[^>]*>\s*(&nbsp;|\u00a0)\s*<\/p>/gi, '')
        // 移除完全空的段落
        .replace(/<p[^>]*>\s*<\/p>/gi, '')
        // 移除段落内联样式中的字号设置（让我们的 CSS 控制字号）
        .replace(/font-size:[^;'"]+;?/gi, '')
        // 移除 font-family 内联样式（让我们的 CSS 控制字体）
        .replace(/font-family:[^;'"]+;?/gi, '');
    },
    getImage(srcString){
      if (!srcString) return '';
      if (srcString.startsWith('/api/') || srcString.startsWith('http')) {
        return srcString;
      }
      const fileName = srcString.split('/').pop(); // Extract filename
      try{
        return require(`@/assets/images/${fileName}`);
      }
      catch(e){
        return srcString;
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.loading-state, .error-state {
  padding: 10rem 0;
  text-align: center;
  font-size: 1.5rem;
  color: white;
  min-height: 50vh;
  background-color: #151414;
}

.hero {
  background-color: #5D719D ;
  background-size: cover;
  background-position: center;
  color: white;
  padding: 8rem 0 18rem 0; /* 增大底部 padding 到 18rem，彻底解决图片遮挡问题 */
  text-align: left;
  position: relative;
  width: 100%;
}

.hero-divider {
  border: none;
  border-top: 1px solid #ffffff; 
  margin: 1.5rem 0 1rem 0; 
  width: 100%; 
}

.hero-date{
  font-size: 14px;
  color: #FFFFFF;
  line-height: 28px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  text-align: justify;
  font-style: normal;
}
.hero-content {
  position: relative;
  z-index: 2;
  max-width: 1000px;
  margin: 0 auto;
  width: 90%;
  padding: 0;
}

.hero h1 {
  font-family: Times New Roman;
  font-size: 70px;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 80px;
  text-align: left;
  font-style: normal;
}

.article-content {
  position: relative;
  background-color: #ffffff;
  color: #111111;
  padding: 18rem 0 4rem 0; 
  width: 100%;
}

.boundary-image-container {
  position: absolute;
  top: 0; 
  left: 50%; 
  transform: translate(-50%, -50%); 
  z-index: 10;
  width: 90%; 
  max-width: 1000px; 
}

.boundary-image-container img{
    width: 1000px;
    height: 500px;
    object-fit: cover;
}
.article-body {
  margin: 0 auto;
  padding: 0;
  width: 900px;
  max-width: 100%;
}

.article-text {
    width: 900px;
    line-height: 33px;
    font-size: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #111111;
    text-align: left;
    font-style: normal;
}

.article-text :deep(p),
.article-text :deep(span),
.article-text :deep(li) {
  font-size: 24px !important;
  line-height: 33px !important;
  font-family: PingFangSC, PingFang SC !important;
  font-weight: 500 !important;
}

.article-text :deep(p) {
  margin-top: 0;
  margin-bottom: 33px;
  padding: 0;
  text-align: justify;
  text-justify: inter-word;
}

/* 消除 Word 导出时每段之间的空占位段落（只含 &nbsp; 的 p 标签） */
.article-text :deep(p:empty),
.article-text :deep(p > o\:p:only-child),
.article-text :deep(.MsoNormal:empty) {
  display: none;
  margin: 0;
  padding: 0;
  height: 0;
  line-height: 0;
  font-size: 0 !important;
}

.back-to-articles {
  margin-top: 3rem;
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid #7a7575;
}

.back-button {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: var(--secondary-color);
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 2rem;
  }

  .article-content {
    padding-top: 12rem;
  }
  
  .meta {
    font-size: 1rem;
  }
  
  .article-body {
    padding: 0 1rem;
    width: 100%;
  }
  
  .article-text {
    width: 100%;
    height: auto;
    min-height: auto;
  }

  .article-text :deep(p),
  .article-text :deep(span),
  .article-text :deep(li) {
    font-size: 1rem !important;
    line-height: 1.5 !important;
  }
}
</style>